
import React from 'react';

interface GoldSectionDividerProps {
  className?: string;
  centered?: boolean;
}

const GoldSectionDivider: React.FC<GoldSectionDividerProps> = ({ 
  className = '', 
  centered = false 
}) => {
  return (
    <div 
      className={`h-0.5 bg-gold w-20 mb-4 ${centered ? 'mx-auto' : ''} ${className}`}
    ></div>
  );
};

export default GoldSectionDivider;
